import api from './api'

export interface WorkOrderAttachment {
  id: number
  originalFilename: string
  storedFilename: string
  filePath: string
  fileSize: number
  contentType: string
  fileExtension?: string
  fileType: 'IMAGE' | 'VIDEO' | 'DOCUMENT' | 'AUDIO' | 'ARCHIVE' | 'OTHER'
  entityType: string
  entityId: number
  uploadedBy: number
  uploadedAt: string
  hasThumbnail?: boolean
  thumbnailPath?: string
}

export const workOrderAttachmentService = {
  getAttachments: async (workOrderId: number): Promise<WorkOrderAttachment[]> => {
    const response = await api.get<{ success: boolean; data: WorkOrderAttachment[] }>(
      `/work-orders/${workOrderId}/attachments`
    )
    return response.data.data
  },

  uploadAttachment: async (
    workOrderId: number,
    file: File,
    uploadedBy: number
  ): Promise<WorkOrderAttachment> => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('uploadedBy', String(uploadedBy))

    // Don't set Content-Type - axios sets multipart/form-data with boundary for FormData
    const response = await api.post<{ success: boolean; data: WorkOrderAttachment }>(
      `/work-orders/${workOrderId}/attachments`,
      formData,
      { timeout: 60000 }
    )
    return response.data.data
  },

  deleteAttachment: async (workOrderId: number, attachmentId: number): Promise<void> => {
    await api.delete(`/work-orders/${workOrderId}/attachments/${attachmentId}`)
  },

  /** Path relativo à API - para usar com api.get() (inclui auth automaticamente) */
  getAttachmentFilePath: (workOrderId: number, attachmentId: number): string =>
    `/work-orders/${workOrderId}/attachments/${attachmentId}/file?disposition=inline`,

  /** Abre o anexo numa nova aba (fetch com auth + blob URL) */
  openInNewTab: async (workOrderId: number, attachmentId: number): Promise<void> => {
    const res = await api.get(
      `/work-orders/${workOrderId}/attachments/${attachmentId}/file?disposition=inline`,
      { responseType: 'blob' }
    )
    const url = URL.createObjectURL(res.data)
    const w = window.open(url, '_blank')
    if (w) setTimeout(() => URL.revokeObjectURL(url), 30000)
    else {
      const a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      a.click()
      setTimeout(() => URL.revokeObjectURL(url), 500)
    }
  },
}
